import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page7() {
  useEffect(() => {
    document.title = "Маяк — Страница 6"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page5" />
        <ForwardLink href="/page7" />
      </div>

      <p style={{ textAlign: "right" }}>6.</p>
      <p>ПРОПУЩЕНО</p>
      <p>– ПОЗЖЕ</p>
      <p>Темно.</p>
      <p>
        Двое мужчин сидят в тесном камбузе. Керосиновая лампа<br/>
        мерцает на столе между ними, она согнута в одну сторону,<br/>
        но все равно работает нормально. МОЛОДОЙ смотрит на еду, пытаясь<br/>
        скрыть свое презрение: теплый скрод и картошка ждут на<br/>
        побитых тарелках. Он скручивает сигарету на столе.<br/>
        Почерневшие от угля руки пачкают бумагу.
      </p>
      <p>СТАРИК ставит две чашки. Жестянку. Колотый фарфор.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Пусть смерть бледная с тройным ужасом<br/>
        сделает океанские пещеры нашей могилой,<br/>
        Бог, который слышит раскаты волн,<br/>
        соблаговоли спасти просящую душу.
      </p>
      <p>
        Он наливает в чашки странную густую жидкость.<br/>
        <i>Самогон?</i>
      </p>
      <p>Он встал для тоста.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        За четыре недели.
      </p>
      <p>
        МОЛОДОЙ делает паузу. <i>Проклятие, выглядит здорово.</i> Ему не помешало бы выпить. Но<br/>
        он колеблется, как будто думает, что его проверяют.
      </p>
      <p>Он решает сосредоточиться на сигарете.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Нет, сэр. Спасибо.
      </p>
      <p style={{ textAlign: "center" }}>
         СТАРИК<br/>
         Плохая примета оставить тост<br/>
         незаконченным, парень.
      </p>
      <p>МОЛОДОЙ прячет сигарету за ухом.</p>
      <p style={{ textAlign: "center" }}>
         МОЛОДОЙ<br/>
         Не сочтите за неуважение, сэр.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Мужчине, который не пьет, лучше всего иметь<br/>
        на это причины.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Разве?
      </p>
      <p style={{ textAlign: "right" }}>6.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page5" />
        <ForwardLink href="/page7" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1708107210/the-lighthouse-script/lchmtnwvvqdvgthphdgn.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page7;
